<template>
  <div class="wrapper">
    <div
      class="inner"
      :class="[{ 'vowel-bg': lesson.category === 'vowel' }]"
      @click="goToLesson(lesson)"
    >
      <div
        class="category"
        :style="
          `background-color:${lesson.category === 'vowel' ? '#f88' : '#555'};
               color:${lesson.category === 'vowel' ? 'white' : 'white'}`
        "
      >
        {{ lesson.category === "vowel" ? "母音" : "子音" }}
      </div>
      <div class="type">{{ lesson.type }}</div>

      <div class="example">{{ lesson.example }}の</div>

      <div class="target-phoneme">{{ lesson.titlePhoneme }}</div>

      <div
        class="lesson-nav-btn"
        :class="[
          { vowel: lesson.category === 'vowel' },
          { consonant: lesson.category === 'consonant' }
        ]"
      >
        /{{ lesson.targetPhoneme }}/のレッスンへ
      </div>

      <!-- <ProgressCircle class="progress" :percentage="Math.ceil(completed)" /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["lesson"],
  methods: {
    goToLesson(lesson) {
      this.$emit("go-to-new-lesson", lesson);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
}

.inner {
  cursor: pointer;
  width: 200px;
  height: 200px;
  position: relative;
  margin: 10px;
  padding: 10px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  border-radius: 5px;
  overflow: hidden;
  background-color: #fafafa;
  /* overflow: hidden; */
  border: 1px solid #ddd;
  &:hover {
    z-index: 100;
    .lesson-nav-btn {
      transform: translateX(0);
      opacity: 1;
    }
  }
}

.category {
  display: inline-block;
  padding: 2px 13px;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 20px;
}

.example {
  text-align: center;
  margin-top: 12px;
  font-weight: bold;
  font-size: 1.1rem;
}

.target-phoneme {
  font-size: 4rem;
  font-weight: bold;
  user-select: none;
  margin-top: -20px;
  text-align: center;
}

.lesson-nav-btn {
  opacity: 0;
  transition: all 0.3s ease;
  transform: translateX(30px);
  font-size: 0.8rem;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  right: 0;
  border: 0;
  color: white;
  padding: 8px 8px 8px 13px;
  margin: auto;
  border-radius: 20px 0 0 20px;
  font-weight: bold;
  z-index: 100;
}

.consonant {
  background-color: #555;
  &:hover {
    background-color: #444;
  }
}

.vowel {
  background-color: #f88;
  &:hover {
    background-color: #f77;
  }
}
.type {
  position: absolute;
  right: 20px;
  top: 14px;
  font-size: 0.9rem;
  color: #aaa;
}

.vowel-bg {
  background-color: #ffefef;
}
</style>
